
/**
 * SEO 配置 - models (Dansk)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Fysik-nøjagtig AI videogenerator | WeryAI',
        description: 'Generer realistiske, fysik-nøjagtige AI videoer med OpenAI Sora 2 med synkroniseret lyd og narrativ konsistens.',
        keywords: 'Sora 2, OpenAI Sora, videomodel, realistisk AI video, tekst til video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Nativ AI-Billedgenerator | WeryAI',
        description: 'Brug WeryAI Image 2 til fantastisk nativ AI-billedgenerering! Flagskibsmodel med avanceret stilkontrol. Gratis credits, intet kort nødvendigt.',
        keywords: 'WeryAI Image 2, nativ AI-billedgenerator, flagskibs AI-billede, studiokvalitet AI, WeryAI Image gratis, hvordan bruger man WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Gratis Grok 2 - xAI Billedgenerator | WeryAI',
        description: 'Brug Grok 2 på WeryAI til kreative AI-billeder! xAI model med kunstnerisk fleksibilitet og unikke stile. Gratis credits, intet kort nødvendigt.',
        keywords: 'Grok 2, Grok AI, xAI billedgenerator, AI-kunst, kreative AI-billeder, Grok 2 gratis, hvordan bruger man Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Billedgenerator Googles Nyeste | WeryAI',
        description: 'Nano Banana 2 drevet af Gemini med verdensviden og realtidssøgning. Generer faktisk nøjagtige, fantastiske billeder med ultrahurtig hastighed.',
        keywords: 'Nano Banana 2, Google AI, Gemini, billedgenerering, tekstgengivelse, multi-subjekt konsistens, 4K, WeryAI',
        og_title: 'Nano Banana 2 Billedgenerator | WeryAI',
        og_description: 'Nano Banana 2 er drevet af Gemini med dyb verdensforståelse og realtidssøgning, der genererer billeder, der er både smukke og faktuelt præcise.',
        twitter_title: 'Nano Banana 2 Billedgenerator | WeryAI',
        twitter_description: 'Nano Banana 2 er drevet af Gemini med dyb verdensforståelse og realtidssøgning, der genererer billeder, der er både smukke og faktuelt præcise.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 AI-billedgenerator',
        twitterImageAlt: 'Nano Banana 2 AI-billedgenerator',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Filmisk AI videogenerator | WeryAI',
        description: 'Kling 2.5 Turbo skaber filmiske AI videoer med avanceret linsestyring, følelsesmæssige udtryk og jævn fysik.',
        keywords: 'Kling 2.5 Turbo, Kling AI, filmisk AI video, linsestyring AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 Avanceret AI-videogenerator | WeryAI',
        description: 'Runway Gen-4 genererer realistiske, konsistente AI-videoer med dybere promptforståelse og smarte redigeringsværktøjer. Prøv det gratis på WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, AI-videogenerator, tekst til video, billede til video, AI-videoredigering, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Videogenerator Avanceret videoproduktion | WeryAI',
        description: 'Generer avancerede AI videoer med Hailuo AI på WeryAI. Med state-of-the-art bevægelsesstyring og realistisk rendering.',
        keywords: 'Hailuo AI, MiniMax, AI videogenerator, bevægelsesstyring, realistisk video, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance AI videogenerator Dans og bevægelse | WeryAI',
        description: 'Seedance AI videogenerator - Dans og bevægelse skabelse on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Instruktørniveau AI-videogenerator | WeryAI',

        description: 'Opret instruktørniveau AI-videoer med Werydance 2.0: multimodale referencer, narrativ konsistens og fysiksimulering. Gratis på WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, AI videogenerator, instruktørniveau video, multimodal video, fysiksimulering, læbesynkronisering, tekst til video, gratis AI video, WeryAI',

        og_title: 'Werydance 2.0 - Instruktørniveau AI-videogenerator | WeryAI',

        og_description: 'Opret instruktørniveau AI-videoer med Werydance 2.0: multimodale referencer, narrativ konsistens og fysiksimulering. Gratis på WeryAI.',

        twitter_title: 'Werydance 2.0 - Instruktørniveau AI-videogenerator | WeryAI',

        twitter_description: 'Opret instruktørniveau AI-videoer med Werydance 2.0: multimodale referencer, narrativ konsistens og fysiksimulering. Gratis på WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Gratis Nano Banana Pro - AI-Billedgenerator | WeryAI',
        description: 'Brug Nano Banana Pro på WeryAI til AI-billeder i højeste kvalitet! Konkurrerer med Midjourney i kvalitet. Gratis credits, intet kort nødvendigt.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google AI-billede, reasoning AI-billede, 4K AI-billede, Nano Banana Pro gratis, hvordan bruger man Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Gratis Nano Banana - AI-Billedgenerator | WeryAI',
        description: 'Brug Nano Banana på WeryAI til nemt at skabe AI-billeder! Alsidig og hurtig AI-billedmodel. Gratis credits, intet kort nødvendigt.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google AI-billede, hurtig AI-generator, karakterkonsistens, Nano Banana gratis, hvordan bruger man Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Gratis FLUX - Prøv AI-Billedgenerator | WeryAI',
        description: 'Brug FLUX på WeryAI til at generere fantastiske AI-billeder! Bygget af Stable Diffusion-teamet med enestående visuel kvalitet. Gratis credits, intet kort nødvendigt.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, AI-billedgenerator, tekst til billede, AI-kunst, FLUX gratis, hvordan bruger man FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Gratis FLUX Kontext - Pro AI-Billedredaktør | WeryAI',
        description: 'Brug FLUX Kontext på WeryAI til professionel AI-billedredigering! Overlegen præcision, avanceret typografi og flertrins redigering. Gratis credits, intet kort nødvendigt.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, AI-billedredaktør, professionelle AI-billeder, typografi AI, FLUX Kontext gratis, hvordan bruger man FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Gratis Imagen 4 - Google AI-Billedgenerator | WeryAI',
        description: 'Brug Google Imagen 4 på WeryAI til fotorealistiske AI-billeder! Alsidig stilkontrol og præcis tekstgenerering. Gratis credits, intet kort nødvendigt.',
        keywords: 'Imagen 4, Google Imagen, Google AI-billedgenerator, tekst til billede, fotorealistisk AI, Imagen gratis, hvordan bruger man Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Gratis Qwen Image - Alibaba AI-Billedmodel | WeryAI',
        description: 'Brug Qwen Image på WeryAI til flersproget AI-kunst! Alibaba open-source model med overlegen tekstrendering. Gratis credits, intet kort nødvendigt.',
        keywords: 'Qwen Image, Alibaba AI, open-source AI-billede, flersproget tekstrendering, Qwen Image gratis, hvordan bruger man Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Gratis Wan AI - Alibaba Billedgenerator | WeryAI',
        description: 'Brug Wan AI på WeryAI til AI-billeder i høj opløsning! Alibaba model med præcis prompt-følgning og fotorealistisk rendering. Gratis credits, intet kort nødvendigt.',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI-billedgenerator, tekst til billede, fotorealistisk AI, Wan AI gratis, hvordan bruger man Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Gratis Seedream 4.0 - ByteDance Billede AI | WeryAI',
        description: 'Brug Seedream 4.0 på WeryAI til ultrahurtig AI-billedgenerering! ByteDance model med forskellige kunststile. Gratis credits, intet kort nødvendigt.',
        keywords: 'Seedream, Seedream 4.0, ByteDance billede AI, ultrahurtig AI-billede, kunstneriske AI-stile, Seedream gratis, hvordan bruger man Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Gratis Dreamina 4.0 - Multimodal Billede AI | WeryAI',
        description: 'Brug Dreamina 4.0 på WeryAI til multimodal AI-billedskabelse! Skitse til billede, stiloverførsel og karakterfusion. Gratis credits, intet kort nødvendigt.',
        keywords: 'Dreamina 4.0, ByteDance billede AI, multimodal AI-billede, skitse til billede, stiloverførsel, Dreamina gratis, hvordan bruger man Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Gratis Seedream 4.5 - ByteDance Billede AI | WeryAI',
        description: 'Brug Seedream 4.5 på WeryAI til flagskibs AI-billedgenerering! Nyeste ByteDance med præcis typografi. Gratis credits, intet kort nødvendigt.',
        keywords: 'Seedream 4.5, ByteDance billede AI, flagskibsmodel, typografi rendering, multi-billede fusion, Seedream 4.5 gratis, hvordan bruger man Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 ByteDance Ultimative AI | WeryAI',
        description: 'Seedream 5.0 er ByteDances mesterværk inden for AI-visuel med nativ 8K-kvalitet, ultimativ semantisk forståelse, multi-subjekt komposition og tekstrendering 2.0. Prøv gratis på WeryAI.',
        keywords: 'Seedream 5.0, AI billedgenerering, 8K kvalitet, semantisk forståelse, multi-subjekt komposition, tekstrendering, ByteDance, WeryAI',
        og_title: 'Seedream 5.0 Billedgenerator | WeryAI',
        og_description: 'Seedream 5.0 er ByteDances mesterværk inden for AI-visuel generering med nativ 8K-kvalitet, ultimativ semantisk forståelse, multi-subjekt komposition og avanceret tekstrendering.',
        twitter_title: 'Seedream 5.0 Billedgenerator | WeryAI',
        twitter_description: 'Seedream 5.0 er ByteDances mesterværk inden for AI-visuel generering med nativ 8K-kvalitet, ultimativ semantisk forståelse, multi-subjekt komposition og avanceret tekstrendering.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 AI-billedgenerator',
        twitterImageAlt: 'Seedream 5.0 AI-billedgenerator',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Professionel AI Vektorgrafik Generator | WeryAI',
        description: 'Recraft V4 Vector er en professionel AI vektorgrafik generator fra Recraft.ai, der genererer redigerbare SVG vektorer med tabsfri skalering, præcis typografi og kontrol af brandstil. Prøv gratis på WeryAI nu.',
        keywords: 'Recraft V4 Vector, AI vektorgenerering, SVG generator, ægte vektor, logo design, UI ikoner, vektorillustration, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Gratis Midjourney - Prøv AI-Kunstgenerator | WeryAI',
        description: 'Brug Midjourney på WeryAI til at skabe kunstneriske AI-billeder! Kendt for betagende æstetik og lyskvalitet. Gratis credits, intet kort nødvendigt.',
        keywords: 'Midjourney, Midjourney AI, AI-kunstgenerator, kunstneriske AI-billeder, Midjourney gratis, Midjourney alternativ, hvordan bruger man Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI Video Generator | WeryAI',
        description: 'Skab fantastiske videoer med Runway Gen-4.5 på WeryAI. Hybrid autoregressiv-diffusions arkitektur for præcis fysik simulation og tidsmæssig konsistens.',
        keywords: 'Runway Gen-4.5, AI video generator, biografkvalitet AI video, fysik simulation, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI Video Generator | WeryAI',
        description: 'Generer høj kvalitet videoer med Kling 2.6 Pro på WeryAI. Native audiovisuel generering, biografkvalitet 1080p, fremragende prompt overholdelse.',
        keywords: 'Kling 2.6 Pro, AI video generator, høj kvalitet AI video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video Generator Præcis kamera kontrol | WeryAI',
        description: 'Generer biografkvalitet AI videoer med Dreamina 3.0 (Jimeng 3.0) på WeryAI. Præcis start/slut frame kontrol, professionelle kamerabevægelser og 1080p høj-dynamisk video generering.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, AI video generator, kamera kontrol, start slut frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI Video Generator Kreativ Video | WeryAI',
        description: 'Frigør din kreativitet på WeryAI med Kling O1 AI video generator. Perfekt til at generere fantasifuldt og unikt videoindhold.',
        keywords: 'Kling O1, AI video generator, kreativ AI video, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Intelligent AI-videogenerator | WeryAI',

        description: 'Opret AI-videoer med Kling 3.0: intelligent storyboarding, flersproget læbesynkronisering og præcis tekstgengivelse. Gratis på WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, AI videogenerator, intelligent storyboarding, læbesynkronisering, tekstgengivelse, tekst til video, billede til video, gratis AI video, WeryAI',

        og_title: 'Kling 3.0 - Intelligent AI-videogenerator | WeryAI',

        og_description: 'Opret AI-videoer med Kling 3.0: intelligent storyboarding, flersproget læbesynkronisering og præcis tekstgengivelse. Gratis på WeryAI.',

        twitter_title: 'Kling 3.0 - Intelligent AI-videogenerator | WeryAI',

        twitter_description: 'Opret AI-videoer med Kling 3.0: intelligent storyboarding, flersproget læbesynkronisering og præcis tekstgengivelse. Gratis på WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Nativ 16s lyd-video AI-generator | WeryAI',

        description: 'Generer nativ 16-sekunders lyd-video med Vidu Q3: smart klipning, præcis tekstgengivelse og flersproget læbesynkronisering. Gratis på WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, AI videogenerator, nativ 16s lyd-video, intelligent storyboarding, tekstgengivelse, læbesynkronisering, tekst til video, billede til video, gratis AI video, WeryAI',

        og_title: 'Vidu Q3 - Nativ 16s lyd-video AI-generator | WeryAI',

        og_description: 'Generer nativ 16-sekunders lyd-video med Vidu Q3: smart klipning, præcis tekstgengivelse og flersproget læbesynkronisering. Gratis på WeryAI.',

        twitter_title: 'Vidu Q3 - Nativ 16s lyd-video AI-generator | WeryAI',

        twitter_description: 'Generer nativ 16-sekunders lyd-video med Vidu Q3: smart klipning, præcis tekstgengivelse og flersproget læbesynkronisering. Gratis på WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Gratis GPT-4o - OpenAI Billedgenerator | WeryAI',
        description: 'Brug GPT-4o på WeryAI til at skabe billeder via samtale! OpenAI med præcis tekstrendering og høj kvalitet. Gratis credits, intet kort nødvendigt.',
        keywords: 'GPT-4o, GPT-4o billede, OpenAI billedgenerator, samtale AI-kunst, GPT-4o gratis, hvordan bruger man GPT-4o billeder, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Gratis GPT Image 1.5 - OpenAI Kunstgenerator | WeryAI',
        description: 'Brug GPT Image 1.5 på WeryAI til næste generation AI-kunst! Nyeste OpenAI model med forbedret kreativitet. Gratis credits, intet kort nødvendigt.',
        keywords: 'GPT Image 1.5, OpenAI billedmodel, AI-kunstgenerator, næste gen AI, GPT Image 1.5 gratis, hvordan bruger man GPT Image 1.5, WeryAI',
    },
}
